import { Pipe, PipeTransform } from '@angular/core';
import { DaysOutputFormat, FuncMinutes2Format } from './funcMinutes2HourFormat';

@Pipe({
    name: 'formatDays'
})
export class FormatDaysPipe implements PipeTransform {

    transform(value: number, pattern: DaysOutputFormat) : string {
        try {
            return FuncMinutes2Format.RenderDays(value, pattern);
        } catch {
            return '';
        }
    }
}
